import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaPills,
  FaUserNurse,
  FaVial,
  FaVideo,
  FaCalendarCheck,
  FaAmbulance,
  FaArrowRight
} from 'react-icons/fa';

const ServiceCards = () => {
  const services = [
    {
      id: 1,
      title: 'Order Medicine',
      subtitle: '2,500+ Products',
      description: 'Get medicines delivered to your doorstep with prescription upload',
      icon: <FaPills />,
      link: '/medicines',
      bgGradient: 'linear-gradient(135deg, #10495e 0%, #1a6b7a 50%, #2c8799 100%)',
      iconBg: '#10495e',
      type: 'link'
    },
    {
      id: 2,
      title: 'Paramedical Services',
      subtitle: '50+ Home Services',
      description: 'Professional nursing & healthcare services at your home',
      icon: <FaUserNurse />,
      link: '/paramedical',
      bgGradient: 'linear-gradient(135deg, #0d3b4a 0%, #10495e 50%, #165c6e 100%)',
      iconBg: '#0d3b4a',
      type: 'link'
    },
    {
      id: 3,
      title: 'Lab Tests & Packages',
      subtitle: '100+ Tests Available',
      description: 'Book diagnostic tests with free home sample collection',
      icon: <FaVial />,
      link: '/medical-tests',
      bgGradient: 'linear-gradient(135deg, #14596e 0%, #18677d 50%, #1c758c 100%)',
      iconBg: '#14596e',
      type: 'link'
    },
    {
      id: 4,
      title: 'Video Consultation',
      subtitle: '24/7 Available',
      description: 'Consult with qualified doctors anytime, anywhere via video',
      icon: <FaVideo />,
      link: '/online-consultation',
      bgGradient: 'linear-gradient(135deg, #0a2f3a 0%, #0d3b4a 50%, #10495e 100%)',
      iconBg: '#0a2f3a',
      type: 'link'
    },
    {
      id: 5,
      title: 'Book Appointment',
      subtitle: 'Same Day Slots',
      description: 'Schedule in-person appointments with specialists near you',
      icon: <FaCalendarCheck />,
      link: '/doctor-list',
      bgGradient: 'linear-gradient(135deg, #185f74 0%, #1c6d82 50%, #207b90 100%)',
      iconBg: '#185f74',
      type: 'link'
    },
    {
      id: 6,
      title: 'Emergency Ambulance',
      subtitle: 'Instant Response',
      description: '24/7 emergency medical transportation service',
      icon: <FaAmbulance />,
      link: 'tel:+917759847474',
      bgGradient: 'linear-gradient(135deg, #dc2626 0%, #e53e3e 50%, #f56565 100%)',
      iconBg: '#dc2626',
      type: 'call'
    }
  ];

  const handleAmbulanceClick = () => {
    window.location.href = 'tel:+917759847474';
  };

  return (
    <div style={{
      padding: '32px 4px',
      background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
      position: 'relative'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '32px'
        }}>
          <h2 style={{
            fontSize: '32px',
            fontWeight: '800',
            color: '#10495e',
            margin: '0 0 8px 0',
            letterSpacing: '-0.5px'
          }}>
            Our Services
          </h2>
          <p style={{
            fontSize: '15px',
            color: '#64748b',
            margin: '0',
            fontWeight: '500'
          }}>
            Complete healthcare solutions at your fingertips
          </p>
        </div>

        {/* Service Cards Grid */}
        <div className="services-grid">
          {services.map((service) => (
            service.type === 'call' ? (
              <div
                key={service.id}
                onClick={handleAmbulanceClick}
                className="service-card-modern"
                style={{
                  background: service.bgGradient,
                  borderRadius: '16px',
                  padding: '24px 20px',
                  color: 'white',
                  cursor: 'pointer',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  border: '2px solid rgba(255,255,255,0.2)',
                  minHeight: '260px'
                }}
              >
                {/* Background Decoration */}
                <div style={{
                  position: 'absolute',
                  top: '-50px',
                  right: '-50px',
                  width: '150px',
                  height: '150px',
                  background: 'rgba(255,255,255,0.1)',
                  borderRadius: '50%',
                  zIndex: 0
                }} />
                <div style={{
                  position: 'absolute',
                  bottom: '-30px',
                  left: '-30px',
                  width: '100px',
                  height: '100px',
                  background: 'rgba(255,255,255,0.08)',
                  borderRadius: '50%',
                  zIndex: 0
                }} />

                {/* Icon Container */}
                <div style={{
                  width: '60px',
                  height: '60px',
                  background: 'rgba(255,255,255,0.25)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '28px',
                  marginBottom: '16px',
                  position: 'relative',
                  zIndex: 1,
                  border: '2px solid rgba(255,255,255,0.4)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                  {service.icon}
                </div>

                {/* Title */}
                <h3 style={{
                  fontSize: '20px',
                  fontWeight: '800',
                  margin: '0 0 6px 0',
                  lineHeight: '1.2',
                  position: 'relative',
                  zIndex: 1,
                  textShadow: '0 2px 8px rgba(0,0,0,0.4)',
                  color: '#ffffff',
                  letterSpacing: '0.3px'
                }}>
                  {service.title}
                </h3>

                {/* Subtitle */}
                <p style={{
                  fontSize: '12px',
                  fontWeight: '700',
                  margin: '0 0 10px 0',
                  opacity: '0.95',
                  position: 'relative',
                  zIndex: 1,
                  background: 'rgba(255,255,255,0.3)',
                  padding: '4px 12px',
                  borderRadius: '12px',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255,255,255,0.2)'
                }}>
                  {service.subtitle}
                </p>

                {/* Description */}
                <p style={{
                  fontSize: '13px',
                  margin: '0 0 16px 0',
                  opacity: '0.92',
                  lineHeight: '1.4',
                  position: 'relative',
                  zIndex: 1,
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  textAlign: 'center'
                }}>
                  {service.description}
                </p>

                {/* CTA Button */}
                <div style={{
                  // width: '100%',
                  background: 'rgba(255,255,255,0.3)',
                  padding: '10px 16px',
                  borderRadius: '12px',
                  backdropFilter: 'blur(10px)',
                  border: '1.5px solid rgba(255,255,255,0.4)',
                  position: 'relative',
                  zIndex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  fontWeight: '700',
                  fontSize: '13px',
                  textShadow: '0 1px 2px rgba(0,0,0,0.2)'
                }}>
                  <span>Call Emergency</span>
                  <FaArrowRight size={12} />
                </div>
              </div>
            ) : (
              <Link
                key={service.id}
                to={service.link}
                className="service-card-modern"
                style={{
                  background: service.bgGradient,
                  borderRadius: '16px',
                  padding: '24px 20px',
                  color: 'white',
                  textDecoration: 'none',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  border: '2px solid rgba(255,255,255,0.2)',
                  minHeight: '260px'
                }}
              >
                {/* Background Decoration */}
                <div style={{
                  position: 'absolute',
                  top: '-50px',
                  right: '-50px',
                  width: '150px',
                  height: '150px',
                  background: 'rgba(255,255,255,0.1)',
                  borderRadius: '50%',
                  zIndex: 0
                }} />
                <div style={{
                  position: 'absolute',
                  bottom: '-30px',
                  left: '-30px',
                  width: '100px',
                  height: '100px',
                  background: 'rgba(255,255,255,0.08)',
                  borderRadius: '50%',
                  zIndex: 0
                }} />

                {/* Icon Container */}
                <div style={{
                  width: '60px',
                  height: '60px',
                  background: 'rgba(255,255,255,0.25)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '28px',
                  marginBottom: '16px',
                  position: 'relative',
                  zIndex: 1,
                  border: '2px solid rgba(255,255,255,0.4)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                  {service.icon}
                </div>

                {/* Title */}
                <h3 style={{
                  fontSize: '20px',
                  fontWeight: '800',
                  margin: '0 0 6px 0',
                  lineHeight: '1.2',
                  position: 'relative',
                  zIndex: 1,
                  textShadow: '0 2px 8px rgba(0,0,0,0.4)',
                  color: '#ffffff',
                  letterSpacing: '0.3px'
                }}>
                  {service.title}
                </h3>

                {/* Subtitle */}
                <p style={{
                  fontSize: '12px',
                  fontWeight: '700',
                  margin: '0 0 10px 0',
                  opacity: '0.95',
                  position: 'relative',
                  zIndex: 1,
                  background: 'rgba(255,255,255,0.3)',
                  padding: '4px 12px',
                  borderRadius: '12px',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255,255,255,0.2)'
                }}>
                  {service.subtitle}
                </p>

                {/* Description */}
                <p style={{
                  fontSize: '13px',
                  margin: '0 0 16px 0',
                  opacity: '0.92',
                  lineHeight: '1.4',
                  position: 'relative',
                  zIndex: 1,
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  textAlign: 'center'
                }}>
                  {service.description}
                </p>

                {/* CTA Button */}
                <div style={{
                  // width: '100%',
                  background: 'rgba(255,255,255,0.3)',
                  padding: '10px 16px',
                  borderRadius: '12px',
                  backdropFilter: 'blur(10px)',
                  border: '1.5px solid rgba(255,255,255,0.4)',
                  position: 'relative',
                  zIndex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  fontWeight: '700',
                  fontSize: '13px',
                  textShadow: '0 1px 2px rgba(0,0,0,0.2)'
                }}>
                  <span>Explore Now</span>
                  <FaArrowRight size={12} />
                </div>
              </Link>
            )
          ))}
        </div>
      </div>

      {/* Styles */}
      <style>{`
        /* Desktop Grid Layout - 3 columns */
        @media (min-width: 1024px) {
          .services-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 24px;
          }

          .service-card-modern:hover {
            transform: translateY(-12px) scale(1.03);
            box-shadow: 0 20px 60px rgba(0,0,0,0.3);
          }
        }

        /* Tablet Layout - 2 columns */
        @media (min-width: 640px) and (max-width: 1023px) {
          .services-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }

          .service-card-modern:hover {
            transform: translateY(-8px) scale(1.02);
            box-shadow: 0 15px 50px rgba(0,0,0,0.25);
          }
        }

        /* Mobile Layout - Horizontal Scroll */
        @media (max-width: 639px) {
          .services-grid {
            display: flex;
            overflow-x: auto;
            scroll-snap-type: x mandatory;
            gap: 16px;
            padding: 0 4px 20px 4px;
            -webkit-overflow-scrolling: touch;
          }

          .services-grid::-webkit-scrollbar {
            height: 8px;
          }

          .services-grid::-webkit-scrollbar-track {
            background: rgba(255,255,255,0.3);
            border-radius: 10px;
          }

          .services-grid::-webkit-scrollbar-thumb {
            background: rgba(16, 73, 94, 0.4);
            border-radius: 10px;
          }

          .services-grid::-webkit-scrollbar-thumb:hover {
            background: rgba(16, 73, 94, 0.6);
          }

          .service-card-modern {
            min-width: 240px !important;
            max-width: 240px !important;
            flex-shrink: 0;
            scroll-snap-align: center;
            padding: 20px 16px !important;
            min-height: 240px !important;
          }

          .service-card-modern:active {
            transform: scale(0.98);
          }
        }

        /* Very small mobile screens */
        @media (max-width: 380px) {
          .service-card-modern {
            min-width: 220px !important;
            max-width: 220px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default ServiceCards;
